export const orderLeadTimeRuleSchema = {
    displayName: 'Order Lead Time Rule',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isHidden: true,
        },
        menuSectionIds: {
            type: 'array',
            elementType: 'mongoId',
            ui: 'table',
            displayName: 'Menu Sections',
            collapse: true,
            placeholder: 'Select a menu section',
            required: true,
        },
        maxItemCountFor15Minutes: {
            displayName: 'ASAP (15 min)',
            type: 'int',
            min: 1,
        },
        maxItemCountFor30Minutes: {
            displayName: '30 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor45Minutes: {
            displayName: '45 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor60Minutes: {
            displayName: '60 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor90Minutes: {
            displayName: '90 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor120Minutes: {
            displayName: '120 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor180Minutes: {
            displayName: '180 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor240Minutes: {
            displayName: '240 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor300Minutes: {
            displayName: '300 mins',
            type: 'int',
            min: 1,
        },
        maxItemCountFor360Minutes: {
            displayName: '360 mins',
            type: 'int',
            min: 1,
        },
    },
};
//# sourceMappingURL=order_lead_time_rule_schema.js.map